const RAW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";

export const API_BASE_URL = RAW_API_BASE_URL.replace(/\/+$/, "");
